import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from '@learningblocks/shared-components/lib/Modal';
import { Glossary as GlossaryComponent } from '@learningblocks/storybook-components/lib/Glossary';

import { useGlossaryHook } from '../Glossary/Glossary.container';
import cname from './style.module.scss';


/**
 * GlossaryProvider
 *  - It is a wrapper component for Glossary Modal
 *  - The component could be wired on to the root of your react appliction
 *    like redux provider to use glossary on the stack
 *  - File exports a context and Component for Glossary which could be used
 *    in your react application.
 */

const Context = React.createContext({});

function Component(props) {
  const [glossaryOpen, setGlossaryOpen] = React.useState(false);
  const [searchText, setSearchText] = React.useState('');
  const hook = useGlossaryHook({
    searchText: searchText,
    categories: props.categories,
    fetchGlossaryList: props.fetchGlossaryList,
    fetchGlossaryItem: props.fetchGlossaryItem,
  });
  const onOpenGlossary = (tooltipItemID) => {

    setSearchText('');

    // Adjusted to rather use item ID
    if(tooltipItemID !== ""){
      hook.onSelectToolTip({
        id: tooltipItemID,
        category: 'recpR5YrmA7YixItg'
      })
    }

    setGlossaryOpen(true);
  };

  const closeGlossary = () => {
    setSearchText('');
    //hook.onTabSelect('recpR5YrmA7YixItg')
    setGlossaryOpen(false);
  };

  const className = `${props.className} ${cname.glossary} glossary_modal`;

  return (
    <Context.Provider value={{onOpenGlossary}}>
      {props.children}
      <Modal isOpen={glossaryOpen} className={className}>
        <GlossaryComponent
          hook={hook}
          searchText={searchText}
          categories={props.categories}
          fetchGlossaryItem={props.fetchGlossaryItem}
          fetchGlossaryList={props.fetchGlossaryList}
          closeGlossary={closeGlossary}
        />
      </Modal>
    </Context.Provider>
  );
}

Component.propTypes = {
  /**
   * React component over which glossary is wrapped to pass glossary operations
   */
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.array])
    .isRequired,
  /**
   * List of categories to be displayed for the search Glossary Items
   */
  categories: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
      selected: PropTypes.bool.isRequired,
    })
  ).isRequired,
  /**
   * Async function to fetch glossary list
   */
  fetchGlossaryList: PropTypes.func.isRequired,
  /**
   * Async function to fetch glossary Item content
   */
  fetchGlossaryItem: PropTypes.func.isRequired,
};

Component.defaultProps = {
  categories: [],
};

export const GlossaryProvider = {Context, Component};
